var React = require('react');
var PropTypes = React.PropTypes;
import '../../css/components/Marking/marking_progress.css';

var MarkingProgress = React.createClass({
  getInitialState: function() {
    return {
      answers: this.props.answers || {},
      currentIndex: this.props.currentIndex || 0
    };
  },
  componentWillReceiveProps: function(nextProps) {
    this.setState({
      answers: nextProps.answers || this.state.answers,
      currentIndex: nextProps.currentIndex !== undefined ? nextProps.currentIndex : this.state.currentIndex
    })
  },
  render: function() {
    var _this = this;
    var currentIndex = this.state.currentIndex;
    return (
      <div className="progress-wrapper">
        { this.state.answers &&
          this.state.answers.map(function(answer, index) {
            return (
              <span
                key={index}
                className={"circle " + ((index === currentIndex) ? "is-current" : (answer.finishMarking ? "is-finished" : (answer.finishMarking === false ? "is-unfinished" : "")))}>
                {index+1}
              </span>
            )
          })
        }
      </div>
    );
  }

});

module.exports = MarkingProgress;



/** WEBPACK FOOTER **
 ** ./src/components/Marking/MarkingProgress.js
 **/